export default /* css */ `
.heading {
  padding-left: calc(var(--ui-sys-unit) * 24);
}

ui-card {
  max-width: 72rem;

  --ui-card-content-padding-left: calc(var(--ui-sys-unit) * 24);
  --ui-card-content-padding-right: calc(var(--ui-sys-unit) * 24);
}

.content {
  padding: 0 calc(var(--ui-sys-unit) * 24);
  max-width: 72rem;
  display: flex;
}

.socials {
  padding: calc(var(--ui-sys-unit) * 16);

  a {
    text-decoration: none;
    display: flex;
    color: hsl(var(--ui-sys-color-primary));
    column-gap: 4px;

    &:not(:last-child) {
      margin-bottom: calc(var(--ui-sys-unit) * 8);
    }
  }
}

.intro {
  font-size: calc(var(--ui-sys-unit) * 20);
  line-height: 1.4;
  font-weight: 900;
}

.keyword {
  background-color: hsl(var(--ui-sys-color-primary));
  color: hsl(var(--ui-sys-color-on-primary));
  padding: 0 calc(var(--ui-sys-unit) * 4);
 /*  color: hsl(var(--stripe-green-color), var(--stripe-green-color-light)); */
}

@media screen and (max-width: 600px) {
  .content {
    flex-direction: column;

    .socials {
      padding: 0;
    }
  }
}
`
